import React, {Component} from 'react'
import {defineMessages, injectIntl} from 'react-intl'

const messages = defineMessages({
    '1_label': {
        id: 'invoice.recurring.month.january_label',
        defaultMessage: 'January',
    },
    '2_label': {
        id: 'invoice.recurring.month.february_label',
        defaultMessage: 'February',
    },
    '3_label': {
        id: 'invoice.recurring.month.march_label',
        defaultMessage: 'March',
    },
    '4_label': {
        id: 'invoice.recurring.month.april_label',
        defaultMessage: 'April',
    },
    '5_label': {
        id: 'invoice.recurring.month.may_label',
        defaultMessage: 'May',
    },
    '6_label': {
        id: 'invoice.recurring.month.june_label',
        defaultMessage: 'June',
    },
    '7_label': {
        id: 'invoice.recurring.month.july_label',
        defaultMessage: 'July',
    },
    '8_label': {
        id: 'invoice.recurring.month.august_label',
        defaultMessage: 'August',
    },
    '9_label': {
        id: 'invoice.recurring.month.september_label',
        defaultMessage: 'September',
    },
    '10_label': {
        id: 'invoice.recurring.month.october_label',
        defaultMessage: 'October',
    },
    '11_label': {
        id: 'invoice.recurring.month.november_label',
        defaultMessage: 'November',
    },
    '12_label': {
        id: 'invoice.recurring.month.december_label',
        defaultMessage: 'December',
    },

})


class MonthLabel extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            month: this.props.month,
        }
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            month: nextProps.month,
        })
    }

    render() {
        if (this.state.month >= 1 && this.state.month <= 12) {
            return this.props.intl.formatMessage(messages[this.state.month + '_label'])
        }
        return ''
    }

}

export default injectIntl(MonthLabel)





// WEBPACK FOOTER //
// ./src/invoice/recurring/monthlabel.component.jsx